import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n/config'; // Inicializar i18n

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);
